import React, { useEffect, useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ProjectImage } from '../types';
import './ImageCarousel.css';

interface ImageCarouselProps {
  images: ProjectImage[];
  projectTitle: string;
}

export const ImageCarousel: React.FC<ImageCarouselProps> = ({ images, projectTitle }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);

    return () => {
      emblaApi.off('select', onSelect);
      emblaApi.off('reInit', onSelect);
    };
  }, [emblaApi, onSelect]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'ArrowLeft') {
        scrollPrev();
      } else if (event.key === 'ArrowRight') {
        scrollNext();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [scrollPrev, scrollNext]);

  return (
    <div className="carousel">
      <br></br>
      <div className="carousel-viewport" ref={emblaRef}>
        <div className="carousel-container">
          {images.map((image, index) => (
            <div className="carousel-slide" key={index}>
              <figure className="carousel-slide-content">
                <img
                  src={image.path}
                  alt={`${projectTitle} screenshot ${index + 1}`}
                  className="carousel-image"
                />
                <figcaption className="carousel-caption">{image.caption}</figcaption>
                <br></br>
              </figure>
            </div>

          ))}
        </div>
        
      </div>
                  <br></br>
       <div> 
      <button
        className="carousel-button"
        onClick={scrollPrev}
        aria-label="Previous image"
      >
        ‹Previous
      </button>
      <button
        className="carousel-button"
        onClick={scrollNext}
        aria-label="Next image"
      >
        ›Next
      </button>

</div>
      
    </div>
  );
};

export default ImageCarousel;
